import moment from "moment";
import { useState } from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, Box, Text, Image, Flex, Input, FormControl, FormLabel, WrapItem, useToast } from "@chakra-ui/react";

import { useApiClient } from "../../../../shared/hooks";

interface IUpdateTripImage{
  source_image_url:string
  destination:string,
  latitude:number,
  longitude:number
}

interface Props {
  isOpen: boolean;
  from_date: string;
  to_date: string;
  destination: string;
  trip_image: string;
  latitude: number;
  source_url: string;
  longitude: number;
  onClose: () => void;
}

function TripModal({ isOpen, from_date, to_date, destination, trip_image, latitude, longitude, source_url, onClose }: Props) {
  const apiClient = useApiClient();

  const [imageSourceURL, setImageSourceURL] = useState<string>(trip_image);
  const [loading,setLoading]=useState(false)
  const toast = useToast();

  const handleSubmit = () => {
    console.log("mmemme");
    const data = {
      source_image_url: imageSourceURL,
      destination: destination,
      latitude: latitude,
      longitude: longitude,
    };

    UpdateFn(data);
  };

  const UpdateFn = async (data: IUpdateTripImage) => {
    try {
      console.log(data, "DAtata");
      setLoading(true)
      const response = await apiClient.updateTripInfo(data);

      if (response.status) {
        setLoading(false)
        console.log("Done");
        // onClose();

        toast.closeAll();
        toast({
          title:"Image Uploaded",
          description:response.message,
          status: "success",
          isClosable: true,
          duration: 2000,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Modal blockScrollOnMount={true} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minH="fit-content"
        zIndex="1"
        minWidth={{
          lg: "60vw",
          md: "80vw",
          base: "98vw",
        }}
      >
        <ModalHeader textAlign="center" fontSize="2xl" fontWeight="bold">
          Trip Details
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" alignItems="center" mb="4" gap={"20px"}>
            <Image
              src={`${trip_image}?${Math.random()}`}
              alt="Trip Image"
              maxH="200px"
              borderRadius="md"
              mb="2"
            />
            <FormControl pt="3">
              <FormLabel>{"Image Source URL"}</FormLabel>
              <Input
                size="sm"
                type="text"
                value={imageSourceURL}
                onChange={(e) => setImageSourceURL(e.target.value)}
                defaultValue={source_url}     
                placeholder={"Paste Image Source URL"}
                required
              />
            </FormControl>
            <WrapItem width={"50%"}>
              <Button
                isLoading={loading}
                loadingText={"Updating"}
                size="sm"
                type="submit"
                width={"100%"}
                variant={"primary"}
                onClick={handleSubmit}
              >
                Update
              </Button>
            </WrapItem>
          </Flex>
          <Box mb="4">
            <Text fontWeight="bold">Destination:</Text>
            <Text>{destination}</Text>
          </Box>
          <Box mb="4">
            <Text fontWeight="bold">From Date:</Text>
            <Text>
              {moment(from_date, "YYYY-MM-DDTHH:mmZ").format("MMMM D, YYYY")}
            </Text>
          </Box>
          <Box mb="4">
            <Text fontWeight="bold">To Date:</Text>
            <Text>
              {moment(to_date, "YYYY-MM-DDTHH:mmZ").format("MMMM D, YYYY")}
            </Text>
          </Box>
        </ModalBody>

        <ModalFooter justifyContent="center">
          <Button colorScheme="blue" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TripModal;
